export default class Clipboard {
    static copy(selection) {
        const data = JSON.stringify(selection);
        if (!data) {
            return false;
        }
        navigator.clipboard.writeText(data);
        return false;
    }

    static paste(tools, factory, selection, speciesCollection) {
        navigator.clipboard.readText()
            .then((text) => {
                try {
                    let data = JSON.parse(text);
                    Object.values(data.species).map((species) => {
                        speciesCollection.add(species);
                    });
                    selection.reset();
                    tools.setTool(
                        'placement',
                        data.elements.map(
                            (element) => factory.make(element)
                        )
                    )
                } catch (e) {
                }
            });
    }
}
